import Icon from 'core/components/icons/Icon'
import Button from 'core/components/buttons/Button'
import { useEffect, useState } from 'react'
import { useRouteError } from 'react-router'
import { datadogLogs } from '@datadog/browser-logs'
import { isChunkLoadError } from 'utils/Functions'

const ErrorBoundaryRoute = () => {
  const error = useRouteError() as Error
  const [id, setId] = useState<number | null>()
  const userTokenId = localStorage.getItem('user-token-id')
  const isChunkError = isChunkLoadError(error)
  const isMac = /mac/i.test(navigator.userAgent)

  useEffect(() => {
    if (!error?.stack) return
    const _id = new Date().getTime()
    setId(_id)
    datadogLogs.logger.error('Route error boundary - UI error', {
      error: {
        message: error.message,
        name: error.name,
        stack: error.stack,
        id: _id,
        pathname: window?.location?.pathname,
        search: window?.location?.search
      },
      componentStack: error.stack,
      source: 'error-boundary'
    })
  }, [userTokenId, error.stack, error.message, error.name])

  console.log({
    stack: error?.stack ?? '',
    authToken: `user-token-id:${userTokenId}`,
    pathname: window?.location?.pathname,
    search: window?.location?.search
  })

  return (
    <div className="flex justify-center items-center gap-5 w-screen h-[100vh] flex-col text-center">
      <Icon
        name="exclamation-mark"
        color="text-white"
        className="bg-dark-4 rounded-full p-1"
      />
      <h1 className="text-dark-4 m-0">Server error</h1>
      <div>
        {isChunkError ? (
          <>
            <p>The page could not load its resources.</p>
            <p>
              Please try a hard refresh (
              {isMac ? 'Cmd+Shift+R' : 'Ctrl+Shift+R'}) and if the problem
              continues{' '}
              <a href="mailto:support@everlance.com" className="underline">
                contact support
              </a>
            </p>
          </>
        ) : (
          <>
            <p>Oh no! Looks like something broke.</p>
            <p>
              Try refreshing the page and if you need more help{' '}
              <a href="mailto:support@everlance.com" className="underline">
                contact support
              </a>
            </p>
          </>
        )}
        <p>
          and reference this number <span className="text-dark-4">{id}</span>.
        </p>
      </div>
      <Button
        variant="primary"
        onClick={() => window.location.assign('/dashboard')}
      >
        Back to home
      </Button>
    </div>
  )
}

export default ErrorBoundaryRoute
